import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';
import LanguageDetector from 'i18next-browser-languagedetector';
import en from './locales/en.json';
import zh from './locales/zh.json';

i18n
  .use(LanguageDetector)
  .use(initReactI18next)
  .init({
    resources: {
      en: { translation: en },
      zh: { translation: zh },
    },
    fallbackLng: 'en',
    interpolation: {
      escapeValue: false,
    },
    detection: {
      order: ['querystring', 'localStorage', 'navigator'],
      lookupQuerystring: 'lang',
      caches: ['localStorage'],
    },
  });

// Listen for language from parent system (via postMessage)
window.addEventListener('message', (event) => {
  if (event.data && typeof event.data.lang === 'string') {
    const lang = event.data.lang.startsWith('zh') ? 'zh' : 'en';
    if (i18n.language !== lang) {
      i18n.changeLanguage(lang);
    }
  }
});

export default i18n;
